import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Tag, Select, Space } from 'antd';
import { PageHeader } from '../../components/common/PageHeader';
import { DataTable } from '../../components/common/DataTable';
import { StatusBadge } from '../../components/common/StatusBadge';
import { useUsersList } from '../../hooks/useUsers';
import { PLAN_LABELS } from '../../lib/constants';
import dayjs from 'dayjs';
import type { AdminUserListItem } from '../../types/users';
import type { ColumnsType } from 'antd/es/table';

export function UsersListPage() {
  const navigate = useNavigate();
  const [params, setParams] = useState({ page: 1, per_page: 20, search: '', is_active: undefined as boolean | undefined, plan: undefined as string | undefined });
  const { data, isLoading } = useUsersList(params);

  const columns: ColumnsType<AdminUserListItem> = [
    { title: 'Name', dataIndex: 'full_name', key: 'full_name', render: (v: string, r) => <a onClick={() => navigate(`/users/${r.id}`)}>{v || r.email}</a> },
    { title: 'Email', dataIndex: 'email', key: 'email' },
    { title: 'Status', dataIndex: 'is_active', key: 'is_active', render: (v: boolean) => <StatusBadge status={v ? 'active' : 'inactive'} /> },
    { title: 'Type', dataIndex: 'is_admin', key: 'type', render: (_: boolean, r) => r.is_admin ? <Tag color="red">Admin</Tag> : <Tag>User</Tag> },
    { title: 'Plan', dataIndex: 'plan_tier', key: 'plan_tier', render: (v: string | null) => v ? <Tag>{PLAN_LABELS[v] || v}</Tag> : '-' },
    { title: 'Invoices', dataIndex: 'invoices_processed', key: 'invoices_processed', align: 'right' },
    { title: 'Created', dataIndex: 'created_at', key: 'created_at', render: (v: string) => dayjs(v).format('MMM D, YYYY') },
  ];

  return (
    <>
      <PageHeader title="Users" subtitle={`${data?.total ?? 0} total users`} />
      <DataTable<AdminUserListItem>
        columns={columns}
        dataSource={data?.data}
        loading={isLoading}
        total={data?.total}
        page={params.page}
        perPage={params.per_page}
        onPageChange={(p, ps) => setParams((s) => ({ ...s, page: p, per_page: ps }))}
        onSearch={(v) => setParams((s) => ({ ...s, search: v, page: 1 }))}
        searchPlaceholder="Search by email or name..."
        extra={
          <Space>
            <Select placeholder="Status" allowClear style={{ width: 120 }} onChange={(v) => setParams((s) => ({ ...s, is_active: v, page: 1 }))} options={[{ label: 'Active', value: true }, { label: 'Inactive', value: false }]} />
            <Select placeholder="Plan" allowClear style={{ width: 120 }} onChange={(v) => setParams((s) => ({ ...s, plan: v, page: 1 }))} options={[{ label: 'Starter', value: 'starter' }, { label: 'Growth', value: 'growth' }, { label: 'Pro', value: 'pro' }, { label: 'Business', value: 'business' }]} />
          </Space>
        }
      />
    </>
  );
}
